import { Text } from "@instructure/ui-text";
import { TopNavBar } from "@instructure/ui-top-nav-bar";
import { View } from "@instructure/ui-view";
import { t } from "i18next";
import logo from "../../src/logo-white-yellow.png";

const TopNav = () => {
  return (
    <TopNavBar>
      {() => (
        <TopNavBar.Layout
          navLabel={t("navigation.publicNav")}
          desktopConfig={{ hideActionsUserSeparator: false }}
          smallViewportConfig={{
            dropdownMenuToggleButtonLabel: t("navigation.toggleMenu"),
            dropdownMenuLabel: t("navigation.mainMenu"),
          }}
          renderBrand={
            <TopNavBar.Brand
              screenReaderLabel={t("navigation.brandName")}
              renderName={
                <View as="div" minWidth="7rem">
                  <Text
                    as="div"
                    color="primary-inverse"
                    size="large"
                    weight="normal"
                    lineHeight="condensed"
                  >
                    {t("navigation.insights")}
                  </Text>
                </View>
              }
              renderIcon={
                <img
                  alt={t("navigation.logoAlt")}
                  style={{ width: "74px", margin: "0 auto" }}
                  src={logo}
                />
              }
            />
          }
        />
      )}
    </TopNavBar>
  );
};

export default TopNav;
